/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useState } from 'react';
import { ethers } from 'ethers'
import reBurnProtocol from './artifacts/contracts/reBurnProtocol.sol/reBurnProtocol.json'
import ECRDummy from './artifacts/contracts/ECRDummy.sol/ECRDummy.json'


function CreateToken(props) {
    const {web3, seedAddress, accounts, myTokens, setMyTokens} = props;
    const [createTokenInfo, setCreateTokenInfo] = useState({
        sourceAddress: "",
        burnAddress: "0x000000000000000000000000000000000000dEaD",
        symbol: "",
        name: "",
        ownerAddress: accounts[0],
        treasuryAddress: "",
        valid: false,
        loading: false,
        creating: false,
        addToMetamask: false
    })

    function bumpState(newStateChunk) {
        setCreateTokenInfo(prev => {return {
                ...prev,
                ...newStateChunk
        }});
    }

    function autoFillCreateForm() {
        if (accounts[0]) {
            bumpState({
                ownerAddress: accounts[0],
                treasuryAddress: accounts[0]
            });
        }
        if (createTokenInfo.sourceAddress) {
            try {
                const lifeContract = new ethers.Contract(createTokenInfo.sourceAddress, ECRDummy.abi, web3)
                bumpState({ loading : true });
                lifeContract.symbol()
                    .then(_symbol => {
                        lifeContract.name()
                            .then(_name => {
                                bumpState({
                                    name: _name + " (reBURN)",
                                    symbol: "re" + _symbol,
                                    valid: true,
                                    loading: false
                                });
                            });
                    })
                    .catch(error => {
                        bumpState({
                            valid: false,
                            loading: false
                        });
                        console.log(error);
                    })
            } catch (error) {
                console.log(error);
                bumpState({
                    valid: false
                });
            }
        }
    }
    function handleCreateTokenInfoChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        bumpState({[name]: value, valid: true})
    }

  async function createToken(event) {
        event.preventDefault();

        const signer = web3.getSigner()
        const protocol = new ethers.Contract(seedAddress, reBurnProtocol.abi, signer)
        try{
            bumpState({ creating : true });
            const tx = await protocol.createToken(createTokenInfo.name, createTokenInfo.symbol,
                                                   createTokenInfo.sourceAddress, createTokenInfo.burnAddress,
                                                   createTokenInfo.treasuryAddress);
            console.log("address is " + (typeof tx) + " " + tx);
            const receipt = await tx.wait();
            console.log("address is " + (typeof receipt) + " " + receipt);
            console.log(receipt.events);

            bumpState({ creating : false });

            for (const event of receipt.events) {
                if (event.event === "Created") {
                    setMyTokens([...myTokens, { address: event.args.token}]);
                    bumpState({ addToMetamask : true });
                }
            }
        } catch (e) {
            bumpState({ creating : false });
            //ignore
            console.log(e);
        }
  }

  async function addCreateTokenToMetamask() {
    try {
      const targetAddress = myTokens[myTokens.length - 1].address;
      const tokenContract = new ethers.Contract(targetAddress, ECRDummy.abi, web3);
      const tokenDecimals = await tokenContract.decimals()
      // wasAdded is a boolean. Like any RPC method, an error may be thrown.
      const wasAdded = await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // Initially only supports ERC20, but eventually more!
          options: {
            address: targetAddress, // The address that the token is at.
            symbol: createTokenInfo.symbol, // A ticker symbol or shorthand, up to 5 chars.
            decimals: tokenDecimals
    //                    image: tokenImage,
          },
        },
      });

      if (wasAdded) {
        console.log('Thanks for your interest!');
      } else {
        console.log('Your loss!');
      }
    } catch (error) {
      console.log(error);
    }
  }
    return (
        <form className="row g-3" onSubmit={createToken}>
          <div className="col-md-6">
            <label htmlFor="createSourceAddress" className="form-label">Source token address</label>
            <input type="text" className={!createTokenInfo.valid ? "form-control is-invalid" : "form-control"} id="createSourceAddress" name="sourceAddress" value={createTokenInfo.sourceAddress} onChange={handleCreateTokenInfoChange}/>
          </div>
          <div className="col-md-6">
            <label htmlFor="createBurnAddress" className="form-label">Source token burn address</label>
            <input type="text" className="form-control" id="createBurnAddress" name="burnAddress" value={createTokenInfo.burnAddress} onChange={handleCreateTokenInfoChange}/>
          </div>
          <div className="col-12">
            <button type="button" className="btn btn-link" onClick={autoFillCreateForm}>Load and auto complete the other fields</button>
            {createTokenInfo.loading &&
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
            }
          </div>
          <div className="col-md-6">
            <label htmlFor="createSymbol" className="form-label">Your token symbol</label>
            <input type="text" className="form-control" id="createSymbol" name="symbol" value={createTokenInfo.symbol} onChange={handleCreateTokenInfoChange}/>
          </div>
          <div className="col-md-6">
            <label htmlFor="createName" className="form-label">Your token name</label>
            <input type="text" className="form-control" id="createName" name="name" value={createTokenInfo.name} onChange={handleCreateTokenInfoChange}/>
          </div>
          <div className="col-12">
            <label htmlFor="createOwnerAddress" className="form-label">Owner address (you, all initial tokens will be deposited here)</label>
            <input type="text" className="form-control" id="createOwnerAddress" name="ownerAddress" value={createTokenInfo.ownerAddress}  readOnly/>
          </div>
          <div className="col-12">
            <label htmlFor="createTreasuryAddress" className="form-label">Treasury address (new tokens minted later will go here, may also be the same as owner)</label>
            <input type="text" className="form-control" id="createTreasuryAddress" name="treasuryAddress" value={createTokenInfo.treasuryAddress} onChange={handleCreateTokenInfoChange}/>
          </div>
          <div className="col-8">
            <button type="submit" className="btn btn-primary" onClick={createToken}>Create my token</button>
          </div>
          <div className="col-4">
            {createTokenInfo.creating &&
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                        }
          </div>
          <div className="col-12">
            {createTokenInfo.addToMetamask &&
                        <div className="alert alert-info" role="alert">
                            <span><small>Created {myTokens[myTokens.length - 1].address}</small>&nbsp;
                            <button className="btn btn-secondary" onClick={addCreateTokenToMetamask}>Add to MetaMask🦊</button>
                            </span>
                        </div>
                        }
          </div>
        </form>
    );
}

export default CreateToken;